module.exports = __webpack_public_path__ + "static/floor_night-0f54a4bd1183983c7d9a4510a2fc4891.jpg";